import { useEffect } from 'react';
import { KEYBOARD_KEY } from '@App/common/constants/keyboardKey';
const useEscapeKeyDown = (open, onKeyDown) => {
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === KEYBOARD_KEY.ESCAPE) {
        onKeyDown();
      }
    };
    if (open) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onKeyDown]);
};
export default useEscapeKeyDown;